import Colors from '../../../../shared/assets/style/default/color';
import Fonts from '../../../../shared/assets/style/default/fonts';
import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';
import ButtonProps from '../../../../shared/types/props/button';

const UpgradeButton = styled.button<ButtonProps>`
  align-self: center;
  background: ${(props) => (props.focused ? '#FF8A00' : 'transparent')};
  border: ${(props) =>
    `${3 * Screen.widthRatio}px solid ${
      props.focused ? '#FF8A00' : Colors['light']
    };`};
  border-radius: ${50 * Screen.widthRatio}px;
  color: ${Colors['light']};
  cursor: pointer;
  font-family: ${Fonts['regular']};
  font-size: ${40 * Screen.widthRatio}px;
  line-height: ${48 * Screen.widthRatio}px;
  margin-right: ${(props) => props.margin || `${40 * Screen.widthRatio}px`};
  padding: ${15 * Screen.widthRatio}px ${55 * Screen.widthRatio}px;
  &:hover {
    background: #ff8a00;
    border-color: #ff8a00;
  }
`;

export default UpgradeButton;
